module.exports = __webpack_public_path__ + "static/doctor_home-501c2a7d527d00c15853a5b9ce09670a.svg";